import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from '@/App';
import '@/index.css';

// A lazy-loaded route chunk can 404 if the browser tab has been open
// since before the last deploy (its index.html still references
// content hashes the server no longer serves). Vite fires this event
// when that happens — reload once to pick up the current build rather
// than showing the router's default crash screen.
window.addEventListener('vite:preloadError', () => {
  const key = 'vynzo-admin-reloaded-on-preload-error';
  if (!sessionStorage.getItem(key)) {
    sessionStorage.setItem(key, '1');
    window.location.reload();
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
